import React from 'react';
import Tooltip from 'react-bootstrap/Tooltip';
import Overlay from 'react-bootstrap/Overlay';
import deleteIcon from 'src/assets/icons/delete.svg';
import editIcon from 'src/assets/icons/editIcon.svg';
import './EventDetailTooltip.scss';
import EventTooltipAddressContainer from './EventTooltipAddressContainer';
import EventTooltipDetail from './EventTooltipDetail';
import { Appointment } from '../Calendar/calendarTypes';
import { stringToObject } from 'src/utils/helpers';
import { EventType } from '../../constants/EventEnums';
import { Typography } from "src/latest/src/components";

interface Prop {
  clientName?: string;
  finalDateTime: string;
  handleDelete: any;
  isCalendarTooltip: boolean;
  isAppointmentTooltip: boolean;
  handleEdit?: any;
  isTooltipVisible?: boolean;
  tooltipTarget: any;
  closeTooltip?: any;
  showTooltip?: any;
  data: Appointment;
}

const EventDetailTooltip: React.FC<Prop> = ({
  clientName,
  finalDateTime,
  handleDelete,
  isCalendarTooltip,
  isAppointmentTooltip,
  handleEdit,
  isTooltipVisible,
  tooltipTarget,
  closeTooltip,
  showTooltip,
  data,
}) => {
  const appointmentLocation: any =
    (isCalendarTooltip && data?.eventType === EventType.Appointment) ||
    isAppointmentTooltip
      ? stringToObject(data?.office_location)
      : data?.office_location;

  return (
    <>
      <Overlay
        rootClose={true}
        target={tooltipTarget?.current}
        show={isCalendarTooltip ? showTooltip : isTooltipVisible}
        placement={isCalendarTooltip ? 'bottom' : 'right'}
        onHide={closeTooltip}
        popperConfig={{
          modifiers: [
            {
              name: 'flip',
              enabled: true,
            },
            {
              name: 'preventOverflow',
              options: {
                boundary: 'viewport',
              },
            },
          ],
        }}
      >
        <Tooltip
          id="event-tooltip"
          placement="bottom"
          className="appointment-tooltip"
        >
          <div className={`tooltip-content ${isCalendarTooltip ? '' : 'mt-5'}`}>
            <div className="tooltip-header">
              <Typography
                weight="bold"
                variant="size-18"
                className="event-title"
              >
                {clientName}
              </Typography>
              <Typography variant="size-16" className="time-string">
                {finalDateTime}
              </Typography>
              {isCalendarTooltip && (
                <Typography variant="size-12" color="color-28" className="mt-2">
                  {data?.event_description}
                </Typography>
              )}
            </div>
            <div className="tooltip-body">
              <EventTooltipDetail keyName={clientName} valueName={'patient'} />
              <EventTooltipDetail
                keyName={
                  data?.therapistDetails?.therapist_name || data?.therapist_name
                }
                valueName={'provider'}
              />
              <EventTooltipDetail
                keyName={data?.scheduler_name}
                valueName={'Scheduler'}
              />
            </div>
            <br />
            <div className="tooltip-body">
              <Typography variant="size-14">
                <div>
                  <Typography
                    variant="size-14"
                    weight="semi-bold"
                    color="color-2"
                  >
                    {`${isCalendarTooltip ? data?.eventType : data.slot_type}`}
                  </Typography>
                </div>
              </Typography>
              <Typography variant="size-14">
                <div className="d-flex">
                  <div>
                    <Typography
                      className="service-type"
                      weight="semi-bold"
                      color="color-2"
                      variant="size-14"
                    >
                      {data?.service_types}
                    </Typography>
                  </div>
                  <div className="ms-2">
                    <Typography
                      weight="semi-bold"
                      color="color-2"
                      variant="size-14"
                    >
                      {`•  ${data?.meeting_pref}`}
                    </Typography>
                  </div>
                </div>
              </Typography>
              <div className="address-container">
                {((isCalendarTooltip &&
                  data?.eventType === EventType.Appointment) ||
                  isAppointmentTooltip) && (
                  <div className="appointmentLocation-in-person-ofc">
                    <EventTooltipAddressContainer
                      appointmentLocation={appointmentLocation}
                    />
                  </div>
                )}

                {isCalendarTooltip &&
                  data?.eventType !== EventType.Appointment && (
                    <Typography
                      variant="size-14"
                      weight="semi-bold"
                      color="color-2"
                    >
                      {appointmentLocation}
                    </Typography>
                  )}
              </div>
            </div>
            <div className="tooltip-footer">
              {isCalendarTooltip && (
                <button onClick={handleEdit} className="edit-button">
                  <img src={editIcon} alt="editIcon" />
                </button>
              )}
              <button onClick={handleDelete} className="delete-button">
                <img src={deleteIcon} alt="deleteIcon" />
              </button>
            </div>
          </div>
        </Tooltip>
      </Overlay>
    </>
  );
};

export default EventDetailTooltip;
